import { render, staticRenderFns } from "./AdminProductsScreen.vue?vue&type=template&id=17278df0&scoped=true&"
import script from "./AdminProductsScreen.vue?vue&type=script&lang=js&"
export * from "./AdminProductsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17278df0",
  null
  
)

export default component.exports